import type { Question } from '@mentimeter/legacy-series-types/question';
import type { Slide as VotingSlide } from '../../compatibility-overrides/voting-types';
import type { CompatibilitySlide } from '../../compatibility-types';
import type { CommonQuestionProperty } from './get-common-question-property';

export const getQuestionInstructionsProperty = (
  target: CompatibilitySlide<'instructions'> | VotingSlide<'instructions'>,
  prop: keyof Question,
) => {
  const staticContents = target.staticContent;

  switch (prop as keyof Omit<Question, CommonQuestionProperty>) {
    case 'question':
      return target.title;
    case 'question_styled':
      return staticContents.styledTitle ?? {};
    default:
      return undefined;
  }
};
